import React, { useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import {useParams} from  'react-router-dom';
import {get, post} from '../../../../../Model/Network/Config/Axios';
import {PageLoader} from '../../../../Common/Components/PageLoader';
import {handleError} from "../../../../Common/fToast/ToastCallback";
import RenderPoDetails from './RenderPoDetails';
import ToggleSwitch from '../../../../Common/fSwitch';
import PoAmend from '../fPoAmend';
import { Modal } from '../../../../Common/fModal/Modal';
// import { DEV_MODE } from '../../../../../Model/Network/Api/config';


const PoDetails = (props) => {

	const [loading,setLoading] = useState(true);
	const [details,setDetails] = useState({});
	const [newDetails,setNewDetails] = useState({});
	const [invoices,setInvoices] = useState([]);
	const [conditions, setConditions] = useState([]);
	const [toggle, setToggle] = useState(false);
	const [modal, setModal] = useState(false);
	const [defaultBank, setDefaultBank] = useState(undefined);
	const [vendorStatus, setVendorStatus] = useState(undefined);
	const {id} = useParams();
	let {poAmendmentRequest} = useSelector(state=>state.auth.config.plugins);
	let DEVMODE = false; //removed the split logic

	useEffect(()=>{
		init();
	},[])

	let getVendorStatus=(id)=>{
		get(`/vendor/contacts/${id}/details`, (e, r) => {
			if(r) {
				setVendorStatus(r.vendorStatus);
			}else if(e){ 
				handleError(e);
			}
		})
	}

	const fetchGrnDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/grnsDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false)
				}
			})
		});
	}

	const fetchBasicDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/basicDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false)
				}
			})})
	}

	const fetchTimelineDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/timelineDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false)
				}
			})
		});
	}

	const fetchAttachmentsDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/attachmentsDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false)
				}
			})
		});
	}

	const fetchInvoicesDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/invoicesDetails`, (e, r) => {
				if (r) {
					setInvoices(r.invoices);
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false)
				}
			})
		});
	}

	const fetchVendorDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/vendorDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					fetchDefaultBankDetails(r.vendor.id)
					fetchConditions();
					if(r.vendor) getVendorStatus(r.vendor.id);
					resolve(true);
				}
				else{
					resolve(false)
				}
			})
		});
	}

	const fetchItemDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/itemsDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false);
				}
			})
		});
	}

	const fetchCostAllocationDetails = () => {
		return new Promise((resolve,reject)=>{
			get(`vendor/po/requests/${id}/costAllocationDetails`, (e, r) => {
				if (r) {
					setNewDetails((prev)=>({...prev,...r}));
					resolve(true);
				}
				else{
					resolve(false);
				}
			})
		});
	}

	let init = async () => {
		if(DEVMODE){
			setLoading(true);
			let results=[];
			results.push(fetchBasicDetails());
			results.push(fetchTimelineDetails());
			results.push(fetchAttachmentsDetails());
			results.push(fetchInvoicesDetails());
			results.push(fetchGrnDetails());
			results.push(fetchVendorDetails());
			results.push(fetchItemDetails());
			results.push(fetchCostAllocationDetails());
			await Promise.allSettled(results);
			setLoading(false);
		}
		else{
			setLoading(true);
			get(`vendor/po/requests/${id}/details`, (e, r) => {
				if (r) {
					setDetails(r);
					fetchDefaultBankDetails(r.vendor.id)
					fetchConditions();
					if(r.vendor) getVendorStatus(r.vendor.id);
					if(DEVMODE){
						setLoading(false);
					}
				}
			})
		}
		// get(`vendor/po/requests/${id}/details`, (e, r) => {
		// 	if (r) {
		// 		setDetails(r);
		// 		fetchDefaultBankDetails(r.vendor.id)
		// 		fetchConditions();
		// 		if(r.vendor) getVendorStatus(r.vendor.id);
		// 		if(DEVMODE){
		// 			setLoading(false);
		// 		}
		// 	}
		// })
	}

	let fetchDefaultBankDetails=(id)=>{
		get(`/vendor/contacts/${id}/banks`, (e, r) => {
            if (r) {
                setDefaultBank(r.defaultBank)
            }
        })
	}

	let fetchConditions=()=>{
		get(`vendor/po/requests/${id}/conditions`, (e, r) => {
            if (r) {
                setConditions(r.conditions);	
				if(!DEVMODE) setLoading(false);
            }
			else if(e){
				//handleError(e);
				if(!DEVMODE) setLoading(false);
			}
        })
	}

	const toggleGin = (val) => {
		post(`vendor/procurement/gin/ginToggle/${id}`, { isGin: val }, (e, r) => {
			if (r) {
				init();
			}
			else if (e) {
				handleError(e);
			}
		})
	}


	if(loading) {
		return(<PageLoader />)
	}
	
	return (
		<>
			{vendorStatus==='BLOCKED' && <div style={{ fontSize: '12px', background: '#FDF0DD', borderRadius: '4px',margin:'20px 35px', padding: '20px', display: 'flex', alignItems: 'center', border:'1px solid rgb(144 150 38 / 57%)' }}>
				<svg style={{ marginRight: 12 }} xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 16 16">
					<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
					<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
				</svg>
				<span style={{fontSize:'medium', display:'flex'}} >
					This Vendor is Blocked. 
				</span> 
			</div>}
			{poAmendmentRequest ?
				<div style={{display:'flex',width:'66%',marginLeft:28,paddingBottom:8}}>
				<ToggleSwitch
					style={{background:'#fff',padding:10,borderRadius:10,marginLeft:5 }}
					label="PO Amendment Request"
					status={toggle}
					callback={() => { 
						 toggle ? setModal(true) : setToggle(!toggle) 
					}}
				/>
			    </div>
			: null}
			{toggle ? 
			   <PoAmend
				details={DEVMODE?newDetails:details}
				invoices={invoices}
				conditions={conditions}
				init={() => init()}
				{...props}
			/> : 
			   <RenderPoDetails
				defaultBank={defaultBank}
				details={DEVMODE?newDetails:details}
				invoices={invoices}
				conditions={conditions}
				toggleGin={toggleGin}
				init={() => init()}
				{...props}
			/>}
			{modal &&
				<Modal
					title={'Confirmation'}
					buttonName={'Yes'}
					des="Please confirm if you want to revert the changes, as doing so will clear all modifications made."
					close={() => setModal(false)}
					onSave={() => {
						setToggle(false)
						setModal(false)
					}}
					show={true}
				>
				</Modal>
			}
		</>
		)

}



export default PoDetails
